import apiClient from "./api.client.service";

interface UserProviderDto {
  providerType: string;
  providerCredentials: any;
}
class UserProvidersService {
  private APIBaseUrl: string;

  constructor() {
    this.APIBaseUrl = process.env.REACT_APP_API_BASE_URL ?? "";
  }

  async getProviders() {
    try {
      const response = await apiClient.get(`${this.APIBaseUrl}/admin/user-providers`);
      return response.data;
    } catch (error) {
      console.error("🚀 ~ UserProvidersService ~ getProviders ~ error:", error);
    }
  }

  async saveProvider(provider: UserProviderDto) {
    try {
      const response = await apiClient.post(
        `${this.APIBaseUrl}/admin/user-providers`,
        provider,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("🚀 ~ UserProvidersService ~ saveProvider ~ error:", error);
    }
  }
}

const userProvidersService = new UserProvidersService();
export default userProvidersService;
